import { render, staticRenderFns } from "./CreatePlayer.vue?vue&type=template&id=8cd06642&"
import script from "./CreatePlayer.vue?vue&type=script&lang=ts&"
export * from "./CreatePlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports